import { useState } from "react";
import { useConfig } from "../../../context/ConfigContext";

export default function RafflePurchases() {
  const { config } = useConfig();
  const apiBase = config.REACT_APP_RAFFLE_BASE_URL;
  const apiKey = config.REACT_APP_ADMIN_API_KEY;

  const [query, setQuery] = useState({ email: "", name: "", ticket: "", paymentId: "" });
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null); // <— store open result ID
  const [message, setmessage] = useState({})

  async function search() {
    setLoading(true);
    setError("");
    setResults([]);

    const params = new URLSearchParams();
    if (query.email) params.append("email", query.email);
    if (query.name) params.append("name", query.name);
    if (query.ticket) params.append("ticket", query.ticket);
    if (query.paymentId) params.append("paymentId", query.paymentId);

    try {
      const res = await fetch(`${apiBase}/search?${params.toString()}`, {
        headers: { "Api-Key": apiKey }, credentials: "include"
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Search failed");

      setResults(data.results || []);
    } catch (err) {
      setError(err.message || "Search failed");
    } finally {
      setLoading(false);
    }
  }

  async function downloadPDF(id) {
    const res = await fetch(`${apiBase}/entry/${id}/pdf`, {
      method: "GET",
      headers: { "Api-Key": apiKey }, credentials: "include"
    });

    const fileName = res.headers.get("FileName")

    if (!res.ok) {
      alert("Failed to download PDF");
      return;
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}`;
    link.click();

    window.URL.revokeObjectURL(url);
  }

  async function reprint(id) {

    const res = await fetch(`${apiBase}/entry/${id}/reprint`,
      {headers: { "Api-Key": apiKey }, method: "POST", credentials: "include"}
    )

    const json = await res.json()
    console.log(json)

    if (res.ok) {
      setmessage({ id, message: "Printing tickets!"})
    } else {
      setmessage({ id, message: "Error printing tickets"})
    }

    setTimeout(() => {
      setmessage("")
    }, 10000);

  }

  return (
    <div className="raffle-section">

      {/* SEARCH INPUTS --------------------------------------- */}
      <div className="raffle-search-grid">
        <label>
          <span>Email</span>
          <input
            className="input"
            value={query.email}
            onChange={(e) => setQuery((q) => ({ ...q, email: e.target.value }))}
          />
        </label>

        <label>
          <span>Name</span>
          <input
            className="input"
            value={query.name}
            onChange={(e) => setQuery((q) => ({ ...q, name: e.target.value }))}
          />
        </label>

        <label>
          <span>Ticket #</span>
          <input
            className="input"
            value={query.ticket}
            onChange={(e) => setQuery((q) => ({ ...q, ticket: e.target.value }))}
          />
        </label>

        <label>
          <span>Payment ID</span>
          <input
            className="input"
            value={query.paymentId}
            onChange={(e) =>
              setQuery((q) => ({ ...q, paymentId: e.target.value }))
            }
          />
        </label>
      </div>

      <div className="actions">
        <button className="btn ghost" onClick={search} disabled={loading}>
          {loading ? "Searching…" : "Search"}
        </button>
      </div>

      {error && <p className="muted small error-text">{error}</p>}

      {/* RESULTS --------------------------------------------- */}
      <div className="raffle-results">
        {results.length === 0 && !loading && (
          <p className="muted small">No results yet. Try a search.</p>
        )}

        {results.map((entry) => {
          const isOpen = openDropdown === entry._id;

          return (
              <div className="raffle-result-row" key={entry._id}>
                  <div className="raffle-result-main">
                      <strong>{entry.name}</strong>

                      <span className="muted small">{entry.email}</span>

                      <span className="muted small">
                          Tickets: {entry.ticketNumbers?.length ?? 0}
                      </span>

                      <span className="muted small">
                          Payment: {entry.squarePaymentId || "N/A"}
                      </span>
                      <span className="muted small">
                        Printed: {entry.printed ? "✅ Yes" : "❌ No"}
                        </span>

                  </div>

              <div className="raffle-result-actions">
                <button className="purchase-button" onClick={() => downloadPDF(entry._id)}>
                  Download PDF
                </button>
                <button
                className="btn ghost"
                onClick={() => reprint(entry._id)}
                >
                  Reprint
                  </button>

                {/* ▼ Ticket dropdown toggle */}
                <button
                  className="purchase-button"
                  onClick={() =>
                    setOpenDropdown(isOpen ? null : entry._id)
                  }
                >
                  {isOpen ? "Hide Tickets" : "Show Tickets"}
                  </button>
                  </div>
                  {message.id === entry._id && message.message !== "" && (
                    <h4>{message.message}</h4>
                    )}


              {/* ▼ DROPDOWN LIST */}
              {isOpen && (
                <div className="ticket-dropdown">
                  <h4>Ticket Numbers</h4>
                  <ul>
                    {entry.ticketNumbers.map((t, i) => (
                      <li key={i}>{t}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}